import { render } from "./CrearPost.vue?vue&type=template&id=0fbc0d30"
import script from "./CrearPost.vue?vue&type=script&lang=js"
export * from "./CrearPost.vue?vue&type=script&lang=js"

import "./CrearPost.vue?vue&type=style&index=0&id=0fbc0d30&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__